module.exports = __webpack_public_path__ + "static/img/user_avatar03.0b090d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_avatar03.png
// module id = 8D2L
// module chunks = 1